// scroll-effect in-view.js
(function () {
  var $elm = document.getElementsByClassName('c-scroll-obj');
  if ($elm.length) {
    inView.offset({
      bottom: 80
    });
    inView('.c-scroll-obj').on('enter', function($target) {
      // $target.classList.add('effect-is-active');
      $target.classList.add('effect-is-active');
    });
  }
  // if ($elm.length) {
  //   for (var i = 0; i < $elm.length; i++) {
  //     inView($elm[i]).once('enter', function() {
  //       console.log('invew');
  //     });
  //   }
  // }

  // if ($elm.length) {
  //   $elm.waypoint(function(direction){
  //     var $target = $(this.element);
  //     if (direction === 'down') {//scroll down
  //       $target.addClass('effect-is-active');
  //     }
  //     else { //scroll up
  //       if ($target.hasClass('effect-is-active')) {
  //       } else {
  //         $target.addClass('effect-is-active');
  //       }
  //     }
  //   }, {
  //     offset: '70%'
  //   });
  // }
}());
